import React, {useState} from "react";
import { Table } from "antd";
import { useSelector, useDispatch } from "react-redux";
import dayjs from "dayjs";
import { approveBranchTransaction } from "../branchTransferPendingThunk";
import { CheckOutlined } from "@ant-design/icons";
import Swal from "sweetalert2";

const BranchTransferPendingTable = ({ printMode = false }) => {
  const { list, loading } = useSelector((state) => state.branchTransferPending);
  const dispatch = useDispatch();
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const columns = [
    { title: "No.", render: (_, __, index) => index + 1 },
    {
      title: "Tran Req Date",
      dataIndex: "tran_date",
      render: (val) => (val ? dayjs(val).format("DD-MM-YYYY") : "-"),
    },
    { title: "Branch Name", dataIndex: "name" },
    { title: "Branch From Account", dataIndex: "from_acc_name" },
    { title: "Receive Account", dataIndex: "to_acc_name" },
    { title: "Request By", dataIndex: "full_name" },
    { title: "Amount", dataIndex: "tran_amount", align: "right" },
   {
    title: "Approve Action",
    render: (_, record) =>
      !printMode && (
        <CheckOutlined
          style={{ cursor: "pointer", fontSize: 20, color: "#1677FF" }}
          onClick={() => {
            Swal.fire({
              title: "Are you sure you want to approve this?",
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: "Approve",
              cancelButtonText: "Cancel",
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
            }).then((result) => {
              if (result.isConfirmed) {
                dispatch(approveBranchTransaction({ tranId: record.tran_id }))
                  .unwrap()
                  .then((res) => {
                    Swal.fire({
                      title: res?.msg || "Approved successfully!",
                      icon: "success",
                    });
                  })
                  .catch((err) => {
                    Swal.fire({
                      title: err?.message || "Something went wrong!",
                      icon: "error",
                    });
                  });
              }
            });
          }}
        />
      ),
    },

  ];

  const grandTotal = list.reduce(
    (sum, row) => sum + (row.tran_amount || 0),
    0
  );

  if (printMode) {
  return (
    <table className="btp-print-table">
      <colgroup>
        <col style={{ width: "5%" }} />
        <col style={{ width: "12%" }} />
        <col style={{ width: "18%" }} />
        <col style={{ width: "22%" }} />
        <col style={{ width: "22%" }} />
        <col style={{ width: "11%" }} />
        <col style={{ width: "10%" }} />
      </colgroup>

      <tbody>
        <tr className="btp-print-heading">
          <td>No.</td>
          <td>Tran Req Date</td>
          <td>Branch Name</td>
          <td>Branch From Account</td>
          <td>Receive Account</td>
          <td>Request By</td>
          <td style={{ textAlign: "right" }}>Amount</td>
        </tr>

        {list.map((row, index) => (
          <tr key={row.tran_id || index}>
            <td>{index + 1}</td>

            <td>
              {row.tran_date
                ? dayjs(row.tran_date).format("DD-MM-YYYY")
                : "-"}
            </td>

            <td>{row.name}</td>
            <td>{row.from_acc_name}</td>
            <td>{row.to_acc_name}</td>
            <td>{row.full_name}</td>

            <td style={{ textAlign: "right" }}>
              {Number(row.tran_amount || 0).toFixed(2)}
            </td>
          </tr>
        ))}

        <tr className="btp-print-total">
          <td colSpan={6} style={{ textAlign: "right" }}>
            Grand Total
          </td>

          <td style={{ textAlign: "right" }}>
            {grandTotal.toFixed(2)}
          </td>
        </tr>
      </tbody>
    </table>
  );
}

  return (
    <Table
      rowKey="tran_id"
      columns={columns}
      dataSource={list}
      loading={loading}
      bordered
      scroll={{ x: "max-content" }}
      pagination={{
        ...pagination,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50"],
      }}
      onChange={handleTableChange}
      summary={() => (
        <Table.Summary.Row>
          <Table.Summary.Cell index={0} colSpan={columns.length - 1} align="right">
            <strong>Grand Total</strong>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={columns.length - 1} align="right">
            <strong>{grandTotal.toFixed(2)}</strong>
          </Table.Summary.Cell>
        </Table.Summary.Row>
      )}
    />
  );
};

export default BranchTransferPendingTable;
